export const AO_TERM_OF_SERVICE_URL = 'https://www.aodocs.com/terms-of-service';
export const AO_PRIVACY_POLICY_URL = 'https://www.aodocs.com/privacy-policy';
